module.exports = __webpack_public_path__ + "media/images/c-projectFeatureLabel/location-b808c368d31d163a971299009d3dab74.svg";